import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import {
  BatchConfigProps,
  StepperControlProps,
} from "pages/geoscape-batch/types";
import MappingTableEnrichment from "./mapping-table-enrichment";
import MappingTableInput from "./mapping-table-input";

interface DefineOutputFileMappingsProps {}

export const DefineOutputFileMappings = (
  props: DefineOutputFileMappingsProps & BatchConfigProps & StepperControlProps
) => {
  const inPutParameters = props.batchConfig.hubInfo.csvHeaders;
  const outPutEnrichment = props.batchConfig.output?.format;

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        variant="h1"
        title="Output - File Mapping"
        subheader="Review the arrangement of your processed data. The 'Column Name'
        displays your file's column names and Attribute displays the attribute
        name from the request and response."
      />

      <CardContent>
        <Typography variant="h6">From Input File</Typography>
        <MappingTableInput inPutParameters={inPutParameters} />
        <Typography variant="h6">Enrichment</Typography>
        <MappingTableEnrichment headers={outPutEnrichment} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            gap: "16px",
          }}
        >
          <Button
            onClick={() =>
              props.setActiveStep(Math.max(props.activeStep - 1, 0))
            }
          >
            Back
          </Button>
          <Button
            onClick={() => {
              props.setActiveStep(
                Math.min(props.activeStep + 1, props.maxSteps)
              );

              props.saveBatchConfig();
            }}
            variant="contained"
          >
            Continue
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
